import { Button, Card, Icon } from '@zillow/constellation-10';
import { IconSearchFilled } from '@zillow/constellation-icons';

import EmptyState from '../../../components/EmptyState';

type Props = {
  searchText: string;
  onClearSearch: () => void;
};

export const FlexiblePropertySearchEmptyState = ({ searchText, onClearSearch }: Props) => {
  return (
    <Card
      tone="neutral"
      elevated={false}
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInline: '400',
        paddingBlock: '400',
        width: '100%',
        minHeight: { xxl: '464px' },
      }}
    >
      <EmptyState
        useCard={false}
        align="center"
        data-testid="FlexiblePropertySearchEmptyState"
        icon={<Icon render={<IconSearchFilled />} size="md" css={{ color: 'icon.subtle' }} />}
        heading="No properties found"
        headingLevel={3}
        body={`No properties match “${searchText}”. Try adjusting your search.`}
        actions={
          <Button
            tone="brand"
            emphasis="outlined"
            onClick={onClearSearch}
            data-testid="FlexiblePropertySearchEmptyStateClearButton"
          >
            Clear search
          </Button>
        }
      />
    </Card>
  );
};
